import { useMutation } from '@tanstack/react-query';
import FetchPromise from '~/agent/fetch-promise';
import { CMS_API_ROOT_URL } from '../constants';

export type CreateLinkParams = {
  url: string;
};

export type CreateLinkResponse = {
  url: string;
  assetId: string;
};

const CreateLink = (CreateLinkParams: CreateLinkParams): Promise<CreateLinkResponse> =>
  FetchPromise.post(`${CMS_API_ROOT_URL}/link`, CreateLinkParams);

export const useCreateLink = () => useMutation(CreateLink);
